/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Checkout } from './Checkout';
import {
    CheckoutFromJSON,
    CheckoutFromJSONTyped,
    CheckoutToJSON,
} from './Checkout';

/**
 * 
 * @export
 * @interface UpdateCheckout200ResponseAllOfData
 */
export interface UpdateCheckout200ResponseAllOfData {
    /**
     * 
     * @type {Checkout}
     * @memberof UpdateCheckout200ResponseAllOfData
     */
    checkout: Checkout;
}

/**
 * Check if a given object implements the UpdateCheckout200ResponseAllOfData interface.
 */
export function instanceOfUpdateCheckout200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "checkout" in value;

    return isInstance;
}

export function UpdateCheckout200ResponseAllOfDataFromJSON(json: any): UpdateCheckout200ResponseAllOfData {
    return UpdateCheckout200ResponseAllOfDataFromJSONTyped(json, false);
}

export function UpdateCheckout200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCheckout200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkout': CheckoutFromJSON(json['checkout']),
    };
}

export function UpdateCheckout200ResponseAllOfDataToJSON(value?: UpdateCheckout200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkout': CheckoutToJSON(value.checkout),
    };
}

